export const getNextPageParamWithServerPagination =
  <T>(pageSize?: number) =>
  (
    lastPage: { data: T[]; total?: number },
    allPages: { data: T[]; total?: number }[]
  ) => {
    // Calculate total items loaded so far
    const totalLoaded = allPages.reduce(
      (sum, page) => sum + page.data.length,
      0
    );

    // If we have a total from the API, use it for precise control
    if (lastPage.total !== undefined && totalLoaded >= lastPage.total) {
      return undefined;
    }

    // Fallback: if no items in last page or fewer than page size
    if (
      pageSize &&
      (lastPage.data.length === 0 || lastPage.data.length < pageSize)
    ) {
      return undefined;
    }

    return allPages.length + 1;
  };
